import _ from 'lodash'

import { COLLECT_COMPAT } from '@/api/apiModules'
import common from '@/utils/common'
export default {
  viewType: 'form',
  module: COLLECT_COMPAT,
  okAction: 'personalPeriCompatibleUpload',
  formatData(data) {
    data.compatibleList = data.compatibleDesc
    return data
  },
  view: {
    title: '添加【外设】兼容性案例',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '550px',
    content: [
      {
        $id: 'peripheralName',
        $type: 'input',
        label: '外设名称',
        rules: [
          {
            notEmpty: '外设名称'
          }
        ]
      },
      {
        $id: 'peripheralType',
        $type: 'select',
        label: '外设类型',
        $el: {
          clearable: true
        },
        $options: 'global/enum/peripheralType',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.label
            }
          })
          return value ? value : ''
        }
      },
      {
        $id: 'interfaceType',
        $type: 'select',
        label: '接口类型',
        $el: {
          clearable: true
        },
        $options: 'global/enum/interfaceType',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.label
            }
          })
          return value ? value : ''
        }
      },
      {
        $id: 'compatibleDesc',
        $type: 'sky-product-os-compat-relate',
        label: '兼容性结论'
        // rules: [
        //   {
        //     notEmpty: '兼容性结论'
        //   }
        // ]
      },
      {
        $id: 'verification',
        $type: 'upload-file',
        label: '兼容性测试文档',
        actions: {
          on: {
            updateValue: 'changeUploadAction'
          }
        },
        rules: [
          { checkFileNameLength: 200 },
          {
            customValidate: {
              validate(validateOther, form, curFormItem) {
                let validator = (rule, val, callback) => {
                  let size = val.size
                  if (size > common.fileSizeMax) {
                    callback(new Error('不能超过最大文件上传30M限制'))
                  } else {
                    callback()
                  }
                }
                return {
                  validator
                }
              }
            }
          },
          {
            suffix: {
              includeSuffixes: ['docx', 'pdf', 'zip'],
              errorMessage: '请选择docx、pdf、zip文件格式的文件进行上传'
            }
          }
        ],
        props: {
          ellipsisMessage: true
        }
      }
    ]
  }
}
